/**
 *
 * key
 *
 */

 const key = 'ZWNBc3NpZ25lZExpc3Q='

 export default key
 